export default "__VITE_ASSET__CWgwmBHq__"